import React from 'react';
import { IEventsList } from '..';
import { IconButton, Tooltip } from '@mui/material';
import { noop } from 'lodash';
import { ReactComponent as DeleteIcon } from '../../../../../assets/icons/deleteIcon.svg';
import { confirmAlert } from 'react-confirm-alert';

export default function DeleteEventAction({ event }: { event: IEventsList }) {
  const deleteEvent = () => {
    if (event?.onDelete) {
      event.onDelete(event?.id ?? '');
    }
  };

  const confirmDelete = () =>
    confirmAlert({
      childrenElement: () => (
        <div className="content-container">
          <div className="content">
            Are you sure you want to delete this event?
          </div>
        </div>
      ),
      buttons: [
        {
          label: '',
          className: 'close-btn',
          onClick: noop,
        },
        {
          label: 'Delete event',
          className: 'secondary',
          onClick: deleteEvent,
        },
        {
          label: `Don't delete`,
          className: 'primary',
          onClick: () => noop,
        },
      ],
      overlayClassName: 'overlay-custom-confirm-alert',
    });

  return (
    <Tooltip title="Delete event">
      <IconButton
        onClick={(event) => {
          event.stopPropagation();
          confirmDelete();
        }}
        size="large">
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
}
